"use strict";
(self.webpackChunkdemel_shopify_template = self.webpackChunkdemel_shopify_template || []).push([
  [19], {
    1973: (e, t, n) => {
      n.r(t), n.d(t, {
        setup: () => d
      });
      var s = n(426),
        o = n(4412),
        a = n(2908),
        i = n(6377);

      function c(e, t, n) {
        return e.animate({
          ...t,
          offset: 0
        }, {
          ...n,
          fill: "backwards"
        })
      }
      var r = n(9535);
      const l = matchMedia("(max-width: 1279px)");

      function d(e) {
        ! function (e) {
          let t;
          const n = Math.max((0, o.U2)("body > main [id$=hero]")?.clientHeight ?? 0, window.innerHeight) + e.clientHeight,
            r = e.clientHeight + 40,
            l = (0, i.P2)((s => {
              requestAnimationFrame((() => {
                let o = window.pageYOffset;
                null != document.querySelector("[data-scroll-container]") && (o = s.scroll.y);
                const a = document.documentElement;
                if (o < e.clientHeight + e.offsetTop ? a.style.setProperty("--header-visible-offset", e.offsetTop + e.clientHeight - o + "px") : a.style.setProperty("--header-visible-offset", "0px"), o >= n) e.classList.contains("has-scrolled") || (e.classList.add("has-scrolled"), a.classList.add("has-scrolled"), a.style.setProperty("--main-offset", r + "px"), c(e, {
                  transform: "translateY(-100%)"
                }, {
                  duration: 500,
                  easing: "cubic-bezier(0.32, 0.24, 0.15, 1)"
                }));
                else if (e.classList.contains("has-scrolled")) {
                  if (o < r) return t?.cancel(), t = void 0, e.classList.remove("has-scrolled"), a.classList.remove("has-scrolled"), void a.style.setProperty("--main-offset", "0");
                  if (t) return;
                  t = c(e, {
                    transform: ["translateY(0)", "translateY(-100%)"]
                  }, {
                    duration: 500,
                    easing: "cubic-bezier(0.32, 0.24, 0.15, 1)"
                  }), t.addEventListener("finish", (() => {
                    t = void 0, e.classList.remove("has-scrolled"), a.classList.remove("has-scrolled"), a.style.setProperty("--main-offset", "0")
                  }))
                }
                a.style.setProperty("--header-height", `${e?.clientHeight}px`)
              }))
            }), 16);
          null != document.querySelector("[data-scroll-container]") ? (async () => {
            const e = new s.ZP({
              el: document.querySelector("[data-scroll-container]"),
              smooth: !window.isSafari,
              getDirection: !0,
              smartphone: {
                breakpoint: 0
              },
              tablet: {
                breakpoint: 0
              }
            });
            window.scrollerElement = e;

            null != document.querySelector(".c-product-recommendations") ? setTimeout((function () {
              e.update()
            }), 2e3) : setTimeout((function () {
              e.update()
            }), 100), e.on("scroll", (e => {
              l(e), document.documentElement.setAttribute("data-direction", e.direction)
            })), (0, o.go)(".js-accordion-trigger", document).forEach((t => {
              (0, a.p)("click", t, (() => {
                setTimeout((function () {
                  e.update()
                }), 500)
              }))
            })), (0, o.go)(".js-tabs-nav-button", document).forEach((t => {
              (0, a.p)("click", t, (() => {
                setTimeout((function () {
                  e.update()
                }), 200)
              }))
            })), e.on("call", ((e, t, n) => {
              const {
                el: s
              } = n;
              let a = (0, o.go)(".js-moving-trigger", document);
              e.includes("updateClass") && "enter" == t && a.forEach((e => {
                e != s && e.classList.remove("is-inview")
              }))
            }))
          })() : (l(), (0, a.p)("scroll", window, l, {
            passive: !0
          }))
        }(e),
          function (e) {
            const t = (0, o.U2)(".js-header-burger", e),
              n = (0, o.U2)(".c-header__nav", e),
              s = document.documentElement;
            s.style.setProperty("--header-height", `${e?.clientHeight}px`), s.style.setProperty("--base-header-height", `${e?.clientHeight}px`), t && (0, a.p)("click", t, (e => {
              n.style.setProperty("--nav-height", `${n?.clientHeight}px`);
              e.currentTarget.classList.toggle("is-mobile-nav-open") ? ((0, o.go)("propify-dialog").forEach((e => e.hide())), (0, r.d)(n)) : (0, r.A)(n)
            }));
            window.addEventListener("resize", (() => {
              s.style.setProperty("--header-height", `${e?.clientHeight}px`);
              s.style.setProperty("--base-header-height", `${e?.clientHeight}px`)
            }))
          }(e),
          function (e) {
            const t = (0, o.go)(".js-subnav", e);
            let n;
            const s = e => {
              t.forEach((t => {
                t !== e && t.classList.remove("has-nav-open")
              }))
            },
              i = e => {
                const t = e.classList.toggle("has-nav-open");
                return t && l.matches && (0, r.d)((0, o.U2)(".c-nav__subnav", e)), t
              },
              c = e => {
                e.classList.remove("has-nav-open"), l.matches && (0, r.A)((0, o.U2)(".c-nav__subnav", e)), n?.()
              };
            for (const e of t) (0, a.p)("click", e, (e => {
              if (e.target instanceof Element) {
                const t = e.target.closest("[data-action]");
                if (!t) return;
                const o = t.getAttribute("data-action");
                if (s(e.currentTarget), n?.(), "open" === o) {
                  const t = e.currentTarget;
                  return void (i(t) && (n = (0, a.p)("click", document, (e => {
                    e.target instanceof Element && !e.target.closest(".c-nav") && c(t)
                  }))))
                }
                if ("close" === o) return void c(e.currentTarget)
              }
            }))
          }(e)
      }
    },
    2908: (e, t, n) => {
      function s(e, t, n, s) {
        return t || (t = document), t.addEventListener(e, n, s), () => t.removeEventListener(e, n, s)
      }
      n.d(t, {
        p: () => s
      })
    },
    9535: (e, t, n) => {
      let s;
      n.d(t, {
        A: () => i,
        d: () => a
      });
      const o = async () => {
        s = await n.e(436).then(n.bind(n, 5239))
      };
      async function a(e, t = {}) {
        s || await o(), s.clearAllBodyScrollLocks(), s.disableBodyScroll(e, t)
      }
      async function i(e) {
        s || await o(), s.enableBodyScroll(e)
      }
    },
    6377: (e, t, n) => {
      n.d(t, {
        Ds: () => o,
        P2: () => s
      });
      const s = (e, t) => {
        let n, s, o;
        return function (...a) {
          const i = this;
          n ? (clearTimeout(s), s = setTimeout((() => {
            Date.now() - o >= t && (e.apply(i, a), o = Date.now())
          }), Math.max(t - (Date.now() - o), 0))) : (e.apply(i, a), o = Date.now(), n = !0)
        }
      },
        o = (e, t = 0) => {
          let n;
          return function (...s) {
            clearTimeout(n), n = setTimeout((() => e.apply(this, s)), t)
          }
        }
    }
  }
]);